module.exports = __webpack_public_path__ + "img/voucher_page_2.5e9ed127.png";